import { Routes, Route, Outlet } from "react-router-dom";
import UsinasContextProvider from "../../usinas/context/UsinasContextProvider";
import { useContext } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import SqlQueriesList from "../pages/SqlQueriesList";

export default function SqlQueriesRoutes() {
  const { userIsAdm } = useContext(MainContext);

  return (
    <>
      <UsinasContextProvider>
        <Routes>
          {userIsAdm && (
            <>
              <Route path="/" element={<SqlQueriesList />} />
            </>
          )}
        </Routes>
        <Outlet />
      </UsinasContextProvider>
    </>
  );
}
